const calcReadTime = wordCount => {
  if (!wordCount) return 0;
  const wordsPerMinute = 200;
  var readTime = Math.ceil(wordCount / wordsPerMinute);
  return readTime === 0 ? 1 : readTime;
};

export { calcReadTime };
